import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';
import globalCourseStore from '../../../../../../../../stores/global-course-store';

export const updateGradesPublishedOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number | undefined,
  isPublished: boolean,
) => {
  try {
    if (
      isNaN(Number(programId)) ||
      isNaN(Number(courseId)) ||
      isNaN(Number(assignmentId))
    ) {
      toast.warn(
        'לא ניתן לאתר את מזהה התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים',
      );
      return;
    }

    const res = await appApi.updateAssignmentGradesPublished(
      programId!,
      courseId!,
      assignmentId!,
      isPublished,
    );

    globalCourseStore.updateCourseDetails(
      res.data.body.metadata.id,
      res.data.body.metadata,
      res.data.body.details,
    );
  } catch (e) {
    console.error(
      `updateGradesPublishedOperation is failed with the programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId}, isPublished: ${isPublished} with the error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  }
};
